import { Flex, Text, Tooltip } from '@chakra-ui/react';
import { formatTimeUnit } from '../../../../../shared/utils';
import { DownArrowIcon, UpArrowIcon } from '../../../../../icons';
import { getMetricLabel } from '../../../utils/contributorList.utils';
import { MetricTooltip } from '../../../types';

interface MetricValueProps {
  value: number;
  unit: 'Days' | 'Minutes' | 'Count';
  percentage?: number;
  improved?: boolean;
  metric?: MetricTooltip;
  subMetric?: string;
  showLable?: boolean;
  viewDetails?: boolean;
  handleViewDetailsClick?: () => void;
}

// This component is used to display the metric value in the contributor table used in TrendCell componne

const MetricValue = ({
  value,
  unit,
  percentage,
  improved,
  metric,
  subMetric,
  showLable = false,
  viewDetails = false,
  handleViewDetailsClick,
}: MetricValueProps) => {
  const numericValue = Number(value);
  return (
    <Flex align="center" w={'full'}>
      <Flex align="center" fontSize="sm" w={'100%'} gap={1}>
        {viewDetails && numericValue !== 0 ? (
          <Tooltip label={'View Details'}>
            <Text
              textDecoration={'underline'}
              textDecorationColor={'primary'}
              color={'primary'}
              cursor={'pointer'}
              onClick={handleViewDetailsClick}
            >
              {formatTimeUnit(value, unit, metric?.name ?? '')}
            </Text>
          </Tooltip>
        ) : (
          <Text>{formatTimeUnit(value, unit, metric?.name ?? '')}</Text>
        )}
        {showLable && getMetricLabel(subMetric ?? '') && (
          <Text fontSize="xs" color="text.secondary2">
            {getMetricLabel(subMetric ?? '')}
          </Text>
        )}
        {percentage !== null &&
          percentage !== undefined &&
          percentage !== 0 && (
            <Flex
              align={'center'}
              justify={'center'}
              color={improved ? '#1DA44A' : '#E65100'}
              ml={'auto'}
            >
              {percentage > 1 ? (
                <UpArrowIcon color={improved ? '#1F7A3D' : '#E65100'} />
              ) : (
                <DownArrowIcon color={improved ? '#1F7A3D' : '#E65100'} />
              )}
              {Math.abs(percentage)}%
            </Flex>
          )}
      </Flex>
    </Flex>
  );
};

export default MetricValue;
